import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Add resource hints for performance
if (typeof window !== 'undefined') {
  // Preconnect to Google Fonts
  const preconnectGoogleFonts = document.createElement('link');
  preconnectGoogleFonts.rel = 'preconnect';
  preconnectGoogleFonts.href = 'https://fonts.googleapis.com';
  document.head.appendChild(preconnectGoogleFonts);
  const preconnectGstatic = document.createElement('link');
  preconnectGstatic.rel = 'preconnect';
  preconnectGstatic.href = 'https://fonts.gstatic.com';
  preconnectGstatic.crossOrigin = 'anonymous';
  document.head.appendChild(preconnectGstatic);
  // Preconnect to CDN for critical images
  const preconnectCDN = document.createElement('link');
  preconnectCDN.rel = 'preconnect';
  preconnectCDN.href = 'https://cdn.magicpatterns.com';
  document.head.appendChild(preconnectCDN);
  // DNS prefetch for Facebook
  const dnsPrefetchFB = document.createElement('link');
  dnsPrefetchFB.rel = 'dns-prefetch';
  dnsPrefetchFB.href = 'https://connect.facebook.net';
  document.head.appendChild(dnsPrefetchFB);
  // Preload LCP image (optimized WebP 66kB)
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = 'https://cdn.magicpatterns.com/uploads/uBAEsi8AVseHCSgsFmEDdQ/mockup-bachata-v99.webp.webp';
  preload.type = 'image/webp';
  (preload as any).fetchPriority = 'high';
  document.head.appendChild(preload);
}
render(<App data-id="element-308" />, document.getElementById('root'));